// Validación del CUI (Código Único de Identificación) del DPI de Guatemala.
// Estructura:
// 8 dígitos correlativos + 1 dígito verificador +
// 2 dígitos de departamento + 2 dígitos de municipio.

const CUI_COUNTRY = 'Guatemala'
export const CUI_LENGTH = 13

const MUNICIPALITIES_BY_DEPARTMENT = {
  1: 17, // Guatemala
  2: 8, // El Progreso
  3: 16, // Sacatepéquez
  4: 16, // Chimaltenango
  5: 13, // Escuintla
  6: 14, // Santa Rosa
  7: 19, // Sololá
  8: 8, // Totonicapán
  9: 24, // Quetzaltenango
  10: 21, // Suchitepéquez
  11: 9, // Retalhuleu
  12: 30, // San Marcos
  13: 32, // Huehuetenango
  14: 21, // Quiché
  15: 8, // Baja Verapaz
  16: 17, // Alta Verapaz
  17: 14, // Petén
  18: 5, // Izabal
  19: 11, // Zacapa
  20: 11, // Chiquimula
  21: 7, // Jalapa
  22: 17 // Jutiapa
}

export const CUI_ERROR_MESSAGE =
  'El número de DPI no es válido. Verifica que tenga los 13 dígitos tal como aparecen en tu documento.'

export const CUI_PLACEHOLDER =
  'Ingresa los 13 dígitos de tu DPI'

export const normalizeCui = (value) =>
  String(value == null ? '' : value)
    .replace(/[\s-]/g, '')

export const requiresCui = (country) =>
  country === CUI_COUNTRY

export const isValidCui = (value) => {
  const cui = normalizeCui(value)

  // 1. Debe contener exactamente 13 dígitos.
  if (!new RegExp(`^\\d{${CUI_LENGTH}}$`).test(cui)) {
    return false
  }

  // 2. Separar las partes del CUI.
  const correlative = cui.slice(0, 8)
  const verifier = Number(cui[8])
  const department = Number(cui.slice(9, 11))
  const municipality = Number(cui.slice(11, 13))

  // 3. Validar que el departamento exista.
  const maxMunicipality = MUNICIPALITIES_BY_DEPARTMENT[department]

  if (!maxMunicipality) {
    return false
  }

  // 4. Validar que el municipio exista dentro del departamento.
  if (
    municipality < 1 ||
    municipality > maxMunicipality
  ) {
    return false
  }

  // 5. Calcular el dígito verificador.
  const total = correlative
    .split('')
    .reduce(
      (sum, digit, index) =>
        sum + Number(digit) * (index + 2),
      0
    )

  const expectedVerifier = total % 11

  // El verificador almacenado es un solo dígito.
  if (expectedVerifier > 9) {
    return false
  }

  // 6. Comparar el dígito calculado con el recibido.
  return expectedVerifier === verifier
}
